import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class TooltipLabelTranslationService {
  constructor(private translate: TranslateService) { }

  getTooltipText(tooltipId: string, translations: any, currentLang?: string): string | null {
    return this.getTranslatedText(tooltipId, translations, currentLang);
  }

  getLabelText(labelId: string, translations: any, currentLang?: string): string | null {
    return this.getTranslatedText(labelId, translations, currentLang);
  }

  findTooltipId(obj: any): string | null {
    return this.findPropertyRecursive(obj, 'tooltip_id');
  }

  findLabelId(obj: any): string | null {
    return this.findPropertyRecursive(obj, 'label_id');
  }

  private getTranslatedText(id: string, translations: any, currentLang?: string): string | null {
    if (!id || !translations?.[id]) return null;
    const data = translations[id];
    const lang = currentLang || this.translate.currentLang || 'en';
    return data[lang] || data.default_value || null;
  }

  private findPropertyRecursive(obj: any, propertyName: string): string | null {
    if (!obj || typeof obj !== 'object') return null;
    if (obj[propertyName]) return obj[propertyName];
    
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          const found = this.findPropertyRecursive(value, propertyName);
          if (found) return found;
        }
      }
    }
    return null;
  }
}
